// Zentrale Unternehmensdaten aus dem Impressum
// Wird von allen SEO-Unterseiten für JSON-LD Schema.org verwendet
export const BUSINESS = {
  name: 'FarbWelt Maler Express Service',
  legalName: 'FarbWelt Maler Express Service UG (Haftungsbeschränkt)',
  street: 'Gneisenaustr. 2',
  postalCode: '41539',
  city: 'Dormagen',
  country: 'DE',
  countryLong: 'Deutschland',
  region: 'Nordrhein-Westfalen',
  phone: '+4921337787688',
  phoneDisplay: '02133 7787688',
  email: 'kontakt@farbwelt-service.de',
  domain: 'https://farbwelt-kalender.de',
  externalSite: 'https://farbwelt-service.de',
  taxNumber: '114/5816/0634',
  vatId: 'DE464523137',
  chamber: 'Handwerkskammer Düsseldorf',
  latitude: 51.0967,
  longitude: 6.8317,
  // Tatsächlich bediente Gebiete (aus bestehendem SEO-Content abgeleitet)
  serviceAreas: [
    'Dormagen', 'Zons', 'Nievenheim', 'Delhoven', 'Hackenbroich',
    'Stürzelberg', 'Straberg', 'Delrath', 'Gohr', 'Rheinfeld', 'Horrem',
    'Neuss', 'Köln', 'Düsseldorf', 'Leverkusen', 'Monheim am Rhein',
    'Grevenbroich', 'Meerbusch'
  ],
  services: [
    'Innenanstriche', 'Fassadenarbeiten', 'Tapezierarbeiten',
    'Lackierarbeiten', 'Spachtelarbeiten', 'Trockenbau',
    'Renovierung', 'Wohnungsübergabe', 'Bodenverlegung'
  ]
};

export function getLocalBusinessSchema(overrides = {}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    '@id': `${BUSINESS.domain}/#organization`,
    name: BUSINESS.legalName,
    alternateName: BUSINESS.name,
    url: BUSINESS.domain,
    telephone: BUSINESS.phone,
    email: BUSINESS.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: BUSINESS.street,
      postalCode: BUSINESS.postalCode,
      addressLocality: BUSINESS.city,
      addressRegion: BUSINESS.region,
      addressCountry: BUSINESS.country
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: BUSINESS.latitude,
      longitude: BUSINESS.longitude
    },
    areaServed: BUSINESS.serviceAreas.map(a => ({ '@type': 'City', name: a })),
    knowsAbout: BUSINESS.services,
    priceRange: '€€',
    sameAs: [BUSINESS.externalSite],
    ...overrides
  };
}

export function getBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: it.item.startsWith('http') ? it.item : `${BUSINESS.domain}${it.item}`
    }))
  };
}
